exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-table .section-title[data-v-421ed3ae]{padding-left:0;padding-top:0;opacity:.7}.detail-table tr td[data-v-421ed3ae]{padding:3px 10px;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-421ed3ae","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/exportOrder/myExportOrderDetail.vue
// module id = 824
// module chunks = 0